<nav class="mobile-app-footer" *ngIf="visible" aria-label="Mobile app navigation">
  <button
    class="mobile-footer-item"
    type="button"
    [disabled]="!hasMultipleTenants"
    (click)="tenantSelected.emit()"
    aria-label="Switch tenant"
  >
    <mat-icon>business</mat-icon>
    <span>Tenants</span>
  </button>

  <a
    class="mobile-footer-item"
    routerLink="/projects"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: true }"
    aria-label="Home"
  >
    <mat-icon>home</mat-icon>
    <span>Home</span>
  </a>

  <button
    class="mobile-footer-item"
    type="button"
    [class.active]="profileOpen"
    (click)="toggleProfile()"
    aria-label="Profile"
  >
    <mat-icon>person_outline</mat-icon>
    <span>Profile</span>
  </button>

  <section class="mobile-profile-card" *ngIf="profileOpen" aria-label="Profile menu">
    <div class="mobile-profile-name">{{ userName || 'Signed-in user' }}</div>
    <button type="button" (click)="logoutSelected.emit(); profileOpen = false">Sign out</button>
  </section>
</nav>
